module.exports = __webpack_public_path__ + "static/media/banner-size-2.bda673f4.webp";